export default "__VITE_ASSET__4b225f70__"